import { result } from "lodash";
import { api } from "../../services";
import Swal from "sweetalert2";

const chat = {
  state: {
    status_loading: {}, // Track loading state for each status
    leads_book_search_results: [],
    getting_leads_book_pagination: false,
    loading_pagination: false,
    has_searched: false,
    is_searching: false,
    searching_leads_book: false,
    chat_search_results: {
      leads: [],
      histories: [],
      tickets: []
    },
    search_results: {
      leads: [],
      messages: [],
    },
    tickets_count: {
      in_operator: 0,
      waiting: 0,
      paused: 0,
      out_of_hour: 0
    },
    // Propriedades do layout
    button_disabled: false,
    loading_chat: true,
    first_load_completed: false,
    modals: {
      advanced_filter: false,
      add_ticket: false,
      open_tickets: false
    },
    getting_tickets: false,
    tickets_in_operator: {
      data: [],
      pagination: [],
      current_page: 1,
    },
    tickets_waiting: {
      data: [],
      pagination: [],
      current_page: 1,
    },
    tickets_paused: {
      data: [],
      pagination: [],
      current_page: 1,
    },
    tickets_out_of_hour: {
      data: [],
      pagination: [],
      current_page: 1,
    },
    scrolling_chat: false,
    info_count_tickets: {},
    updated_after_filter: {
      in_operator: false,
      waiting: false,
      paused: false,
      out_of_hour: false,
    },
    ui: {
      mobile: false,
      active: 0,
      open_chat: false,
      open_chat_id: null,
      row_textarea: 1,
      details: false,
      // details: true, Faz os detalhes do lead iniciarem no momento que abrimos o chat
      ticket_history: false,
    },
    ticket: {
      negotiation: {}
    },
    tickets: [],
    histories_current_ticket: [],
    old_histories: [],
    old_tickets: [],
    status_key: null,
    search: "",
    lead_check: {},
    wallet_check: {},
    leads_book_pagination: [],
    active_leads_book: false,
    filter_search: {
      status_key: null,
      channel_id: 0,
      department_id: 0,
      tag_id: 0,
      pipeline_id: 0,
      user_id: 0,
      is_operator: false
    },
    filter_applied: false,
    departments_available: [],
    tags_available: [],
    pipelines_available: [],
    new_ticket: {
      department_id: null,
      operator_id: null
    },
    ticket_transfer: {
      operator_id: null,
      department_id: null
    },
    files: [],
    text: "",
    isShowEmoji: false,
    new_sms: {
      text: "",
    },
    new_email: {
      text: "",
      subject: "",
      file: null,
      mimetype: null,
      filename: null,
    },
    new_vcard: {
      name: "",
      phone: "",
      text: "",
    },
    new_location: {
      address: "",
      latitude: null,
      longitude: null,
    },
    show_media: null,
    integration: {
      open: false
    },
    hsm: {
      step: 1,
      data: {},
      history: {
        language: null,
        name: null,
        namespace: null,
        components: [
          {
            type: 'body',
            parameters: []
          }
        ],
      }
    },
    history_reply: null,
    // btn_resend_message: true,
    load_resend_message: false
  },
  getters: {

    getChatTicketsCount: (state) => (status_key) => {
      const statusMappings = {
        0: 'waiting',
        2: 'out_of_hour',
        3: 'in_operator',
        4: 'paused'
      };

      const statusProperty = statusMappings[status_key];
      return statusProperty ? state.tickets_count[statusProperty] : 0;
    },
    filterDepartmentsAvailableOnChat: (state) => (key, value) => {
      if (state.departments_available !== undefined) {
        return state.departments_available.filter(item => {
          return item[`${key}`] === value;
        });
      }
      return [];
    },
    filterTagsAvailableOnChat: (state) => (key, value) => {
      if (state.tags_available !== undefined) {
        return state.tags_available.filter(item => {
          return item[`${key}`] === value;
        });
      }
      return [];
    },
    filterPipelinesAvailableOnChat: (state) => (key, value) => {
      if (state.pipelines_available !== undefined) {
        return state.pipelines_available.filter(item => {
          return item[`${key}`] === value;
        });
      }
      return [];
    },
    getChatTicketObject: (state) => (key, value) => {
      const object = state.tickets.find(item => {
        return item[`${key}`] === value;
      });
      return object === undefined ? {} : object;
    },
    getChatTicketsArray: (state) => (key, value) => {
      if (state.tickets !== undefined) {
        return state.tickets.filter(item => {
          return item[`${key}`] === value;
        });
      }
      return [];
    },
    getChatTicketsFilter: (state, context) => (status_key = null) => {
      // const current_status = status_key != null ? status_key : state.filter_search.status_key;
      const current_status = status_key;

      // Se há uma busca ativa e resultados de busca, usar os resultados da busca
      if (state.search.trim() !== "" && state.chat_search_results && state.chat_search_results.tickets && state.chat_search_results.tickets.length > 0) {
        if (current_status === null) {
          return _.orderBy(state.chat_search_results.tickets, ['latest_history_created_at'], ['desc']);
        } else {
          return _.orderBy(state.chat_search_results.tickets.filter(ticket => ticket.status_key == current_status), ['latest_history_created_at'], ['desc']);
        }
      }
      if (state.tickets !== undefined) {
        const tickets_filtered = state.tickets.filter(ticket => {
          return ticket.status_key == current_status
        });

        if (current_status === null && state.search.trim() === "") {
          return _.orderBy(state.tickets, ['latest_history_created_at'], ['desc'])
        } else if (current_status >= 0 && state.search.trim() === "") {
          // return _.orderBy(state.tickets.filter(item => {
          //   return item.status_key == current_status;
          // }), ['latest_history_created_at'], ['desc']);
          return _.orderBy(tickets_filtered, ['latest_history_created_at'], ['desc']);
        }
        // else if (current_status === null && state.search.trim() !== "") {
        //   return _.orderBy(tickets_filtered.filter(item => {
        //     let lead = context.getLeadObject('id', item.lead_id);
        //     const isSearchName = lead.name ? lead.name.toLowerCase().includes(state.search.trim().toLowerCase()) : false
        //     const isSearchPhone = lead.phone ? lead.phone.toLowerCase().includes(state.search.trim().toLowerCase()) : false
        //     const isSearchEmail = lead.email ? lead.email.toLowerCase().includes(state.search.trim().toLowerCase()) : false
        //     const isSearchOffice = lead.office ? lead.office.toLowerCase().includes(state.search.trim().toLowerCase()) : false
        //     const isSearchCompany = lead.company ? lead.company.toLowerCase().includes(state.search.trim().toLowerCase()) : false
        //     return isSearchName || isSearchPhone || isSearchEmail || isSearchOffice || isSearchCompany;
        //   }), ['latest_history_created_at'], ['desc']);
        // }
        else {
          return _.orderBy(tickets_filtered.filter(ticket => {
            let lead = context.getLeadObject('id', ticket.lead_id);
            const isSearchName = lead.name ? lead.name.toLowerCase().includes(state.search.trim().toLowerCase()) : false
            const isSearchPhone = lead.phone ? lead.phone.toLowerCase().includes(state.search.trim().toLowerCase()) : false
            const isSearchEmail = lead.email ? lead.email.toLowerCase().includes(state.search.trim().toLowerCase()) : false
            const isSearchOffice = lead.office ? lead.office.toLowerCase().includes(state.search.trim().toLowerCase()) : false
            const isSearchCompany = lead.company ? lead.company.toLowerCase().includes(state.search.trim().toLowerCase()) : false
            return ticket.status_key === current_status && (isSearchName || isSearchPhone || isSearchEmail || isSearchOffice || isSearchCompany);
          }), ['latest_history_created_at'], ['desc'])
        }
      }
      return [];
    }
  },
  mutations: {
    SYNC_TICKET_STATUS(state, { ticketId, newStatus }) {
      // Atualizar o ticket na lista principal
      const ticketIndex = state.tickets.findIndex(ticket => ticket.id === ticketId);
      if (ticketIndex !== -1) {
        state.tickets[ticketIndex].status_key = newStatus;
      }

      // Se for o ticket ativo, atualizar também
      if (state.ticket && state.ticket.id === ticketId) {
        state.ticket.status_key = newStatus;
      }

      // Atualizar nas listas específicas de status se existirem
      const statusListMap = {
        2: 'tickets_out_of_hour',
        4: 'tickets_paused',
        0: 'tickets_waiting',
        3: 'tickets_in_operator'
      };

      Object.entries(statusListMap).forEach(([status, listKey]) => {
        if (state[listKey] && state[listKey].data) {
          const ticketIndex = state[listKey].data.findIndex(ticket => ticket.id === ticketId);
          if (ticketIndex !== -1) {
            state[listKey].data[ticketIndex].status_key = newStatus;
          }
        }
      });
    },
    SET_FIRST_LOAD_COMPLETED(state, payload) {
      state.first_load_completed = payload;
    },
    SET_STATUS_LOADING(state, { status_key, loading }) {
      if (!state.status_loading) {
        state.status_loading = {};
      }
      state.status_loading[status_key] = loading;
    },

    RESET_UPDATED_FILTERS(state) {
      state.updated_after_filter = {
        in_operator: false,
        waiting: false,
        paused: false,
        out_of_hour: false,
      };
    },

    SET_GETTING_LEADS_BOOK_PAGINATION(state, status) {
      state.getting_leads_book_pagination = status;
    },

    SET_LOADING_PAGINATION(state, status) {
      state.loading_pagination = status;
    },

    SET_SEARCHING_LEADS_BOOK(state, searching) {
      state.searching_leads_book = searching;
    },

    SET_IS_SEARCHING(state, value) {
      state.is_searching = value;
    },

    SET_CHAT_LOADING(state, loading) {
      state.loading_chat = loading;
    },
    SET_LEADS_BOOK_SEARCH_RESULTS(state, payload) {
      state.leads_book_search_results = payload;
    },
    SET_SEARCH_STATUS(state, { is_searching, has_searched }) {
      state.is_searching = is_searching;
      state.has_searched = has_searched;
    },
    // SET_GETTING_TICKETS(state, getting) {
    //   state.chat.getting_tickets = getting;
    // },
    // SET_PAGINATION_LOADING(state, loading) {
    //   state.chat.loading_pagination = loading;
    // },



    // SET_IS_SEARCHING(state, searching) {
    //   state.is_searching = searching;
    // },
    SET_HAS_SEARCHED(state, searched) {
      state.has_searched = searched;
    },
    SET_TICKETS_COUNT(state, payload) {
      // console.log('Atualizando contadores:', payload);
      state.tickets_count = payload;
    },
    SET_WAITING_COUNT(state, count) {
      state.tickets_count.waiting = count;
    },
    SET_TICKETS_WAITING(state, payload) {
      state.tickets_waiting = {
        data: payload.data,
        pagination: payload.pagination,
        current_page: payload.current_page
      };
    },
    SET_CHAT_TICKET(state, payload) {
      if (payload.negotiation === null) {
        payload.negotiation = {
          amount: 0
        }
      }
      state.ticket = payload
    },
    SET_CHAT_TICKETS(state, payload) {
      state.tickets = payload
    },
    SET_OLD_HISTORIES(state, payload) {
      state.old_histories = payload
    },
    SET_OLD_TICKETS(state, payload) {
      state.old_tickets = payload
    },
    SET_LEAD_CHECK(state, payload) {
      state.lead_check = payload
    },
    SET_WALLET_CHECK(state, payload) {
      state.wallet_check = payload
    },
    SET_LEADS_BOOK_PAGINATION(state, pagination) {
      state.leads_book_pagination = pagination;
    },
    // SET_BTN_RESEND_MESSAGE(state, payload) {
    //   state.btn_resend_message = payload
    // },
    SET_LOAD_RESEND_MESSAGE(state, payload) {
      state.load_resend_message = payload
    },
    SET_CHAT_SEARCH(state, payload) {
      state.search = payload;
    },

    SET_CHAT_SEARCH_RESULTS(state, payload) {
      state.chat_search_results = {
        leads: payload.leads || [],
        histories: payload.histories || [],
        tickets: payload.tickets || []
      };
    },
  },
  actions: {
    async searchLeadsBook(context, { query, page = 1 }) {
      try {
        // Definir estado de loading antes da requisição
        context.commit('SET_SEARCHING_LEADS_BOOK', true);
        context.commit('SET_IS_SEARCHING', true);
        context.commit('SET_HAS_SEARCHED', true);

        const params = {
          search: query,
          page: page,
          per_page: 15
        };

        const response = await api.get('/leads', { params });

        if (page === 1) {
          context.commit('SET_LEADS_BOOK_PAGINATION', response.data);
        } else {
          const currentData = context.state.leads_book_pagination?.data || [];
          const newData = [...currentData, ...response.data.data];
          context.commit('SET_LEADS_BOOK_PAGINATION', {
            ...response.data,
            data: newData
          });
        }

        return response.data;
      } catch (error) {
        console.error('Erro ao buscar leads:', error);
        throw error;
      } finally {
        // Garantir que o estado de loading seja desativado
        context.commit('SET_SEARCHING_LEADS_BOOK', false);
        context.commit('SET_IS_SEARCHING', false);
      }
    },

    //   async updateTicketCounts(context) {
    //   try {
    //     const response = await api.get('/chat/tickets/count', { 
    //       params: context.state.filter_search 
    //     });
    //     context.commit('SET_TICKETS_COUNT', response.data);
    //   } catch (error) {
    //     console.error('Erro ao atualizar contadores:', error);
    //   }
    // },
    async loadMoreChatTickets(context, params) {
      // Verificar se já está carregando
      if (context.state.getting_tickets) {
        return;
      }

      // Para paginação, usar um flag específico ao invés de getting_tickets
      context.commit('SET_LOADING_PAGINATION', true);

      try {
        const response = await api.get('/chat/tickets', { params });

        if (response.data.data.length > 0) {
          // Carregar dados dos leads
          await context.dispatch("getLeadsData", response.data.data);

          // Filtrar tickets duplicados antes de adicionar
          const existingIds = new Set(context.state.tickets.map(t => t.id));
          const newTickets = response.data.data.filter(ticket => !existingIds.has(ticket.id));

          if (newTickets.length > 0) {
            context.state.tickets.push(...newTickets);
          }

          // Atualizar informações de paginação específicas do status
          const statusKey = params.status_key;
          const statusMappings = {
            0: 'tickets_waiting',
            2: 'tickets_out_of_hour',
            3: 'tickets_in_operator',
            4: 'tickets_paused'
          };

          const statusProperty = statusMappings[statusKey];
          if (statusProperty && context.state[statusProperty]) {
            // Atualizar dados específicos do status
            const existingStatusIds = new Set(context.state[statusProperty].data.map(t => t.id));
            const newStatusTickets = response.data.data.filter(ticket => !existingStatusIds.has(ticket.id));

            if (newStatusTickets.length > 0) {
              context.state[statusProperty].data.push(...newStatusTickets);
            }

            context.state[statusProperty].current_page = response.data.current_page;
            context.state[statusProperty].pagination = response.data;
          }
        }
      } catch (error) {
        console.error('Erro ao carregar mais tickets:', error);
      } finally {
        context.commit('SET_LOADING_PAGINATION', false);
      }
    },

    async searchTickets(context, { query, status_key }) {
      try {
        context.commit('SET_IS_SEARCHING', true);
        context.commit('SET_CHAT_SEARCH', query);
        const params = {
          search: query,
          current_status_key: status_key,
        };
        const response = await api.get('/chat/search-tickets', { params });
        if (response.data.data) {
          await context.dispatch("getLeadsData", response.data.data);
          context.commit('SET_CHAT_SEARCH_RESULTS', {
            tickets: response.data.data,
            leads: [],
            histories: []
          });
          context.commit('SET_HAS_SEARCHED', true);
        }
        return response.data;
      } catch (error) {
        console.error('Erro ao buscar tickets:', error);
        if (error.response?.status === 401) {
          await context.dispatch('logoutUser');
        }
        throw error;
      } finally {
        context.commit('SET_IS_SEARCHING', false);
      }

    },

    // async callRequestsPagination(context, {pages, query_params}) {
    //   let data = [];
    //   for(const page of pages) {
    //     let new_query_params = query_params
    //     new_query_params.page = page;
    //     await api.get('/chat/tickets', { params: new_query_params }).then(response => {
    //       if (response.data.data.length > 0) {
    //         this.dispatch("getLeadsData", response.data.data);
    //         data.push(...response.data.data);
    //       }
    //     })
    //   }

    //   if(query_params.status_key == 3) {
    //     this.dispatch('getTicketsWaiting', query_params);
    //   } 
    //   else if (query_params.status_key == 0) {
    //     this.dispatch('getTicketsPaused', query_params);
    //   }
    //   else if (query_params.status_key == 4) {
    //     this.dispatch('getTicketsOutOfHour', query_params);
    //   }
    //   else if (query_params.status_key == 2) {
    //     context.state.filter_search.status_key = 3;
    //     this.dispatch('stopLoading');
    //     context.state.first_load_completed = true;
    //     context.state.getting_tickets = false;
    //   }

    //   if (data.length > 0) {
    //     context.state.tickets.push(...data);
    //   }

    //   // return data;
    // },
    async getTicketsInOperator(context, query_params) {
      query_params.status_key = 3;
      query_params.page = 1;
      await api.get('/chat/tickets', { params: query_params }).then(first_response => {

        if (first_response.data.data.length > 0) {
          this.dispatch("getLeadsData", first_response.data.data);

          // Filter out duplicates before adding to tickets array
          const existingIds = new Set(context.state.tickets.map(t => t.id));
          const newTickets = first_response.data.data.filter(ticket => !existingIds.has(ticket.id));

          if (newTickets.length > 0) {
            context.state.tickets.push(...newTickets);
          }
        }

        context.state.tickets_count.in_operator = first_response.data.total || 0;
        context.state.tickets_in_operator = {
          data: first_response.data.data,
          pagination: first_response.data,
          current_page: first_response.data.current_page
        };
        context.state.filter_search.status_key = 3;
        this.dispatch('stopLoading');
        context.state.first_load_completed = true;
        context.state.getting_tickets = false;
      })
    },
    async getTicketsWaiting(context, query_params) {
      query_params.status_key = 0;
      query_params.page = 1;
      try {
        const response = await api.get('/chat/tickets', { params: query_params });

        if (response.data.data.length > 0) {
          await context.dispatch("getLeadsData", response.data.data);

          // Filter out duplicates before adding to tickets array
          const existingIds = new Set(context.state.tickets.map(t => t.id));
          const newTickets = response.data.data.filter(ticket => !existingIds.has(ticket.id));

          if (newTickets.length > 0) {
            context.state.tickets.push(...newTickets);
          }
        }

        context.commit('SET_LOADING_PAGINATION', false);
        context.commit('SET_GETTING_LEADS_BOOK_PAGINATION', false);
        context.commit('SET_LEADS_BOOK_PAGINATION', context.state.leads_book_pagination);

        // Atualizar contador com valor do servidor
        const waitingCount = response.data.total || 0;
        context.commit('SET_WAITING_COUNT', waitingCount);

        context.commit('SET_TICKETS_WAITING', {
          data: response.data.data,
          pagination: response.data,
          current_page: response.data.current_page
        });

        // console.log('Contador waiting atualizado:', waitingCount); 
      } catch (error) {
        console.error('Erro ao carregar tickets em waiting:', error);
        throw error;
      }
    },
    async getTicketsPaused(context, query_params) {
      query_params.status_key = 4;
      query_params.page = 1;
      await api.get('/chat/tickets', { params: query_params }).then(first_response => {

        if (first_response.data.data.length > 0) {
          this.dispatch("getLeadsData", first_response.data.data);

          // Filter out duplicates before adding to tickets array
          const existingIds = new Set(context.state.tickets.map(t => t.id));
          const newTickets = first_response.data.data.filter(ticket => !existingIds.has(ticket.id));

          if (newTickets.length > 0) {
            context.state.tickets.push(...newTickets);
          }
        }
        context.state.tickets_count.paused = first_response.data.total || 0;
        context.state.tickets_paused = {
          data: first_response.data.data,
          pagination: first_response.data,
          current_page: first_response.data.current_page
        };
      })
    },
    async getTicketsOutOfHour(context, query_params) {
      query_params.status_key = 2;
      query_params.page = 1;
      await api.get('/chat/tickets', { params: query_params }).then(first_response => {

        if (first_response.data.data.length > 0) {
          this.dispatch("getLeadsData", first_response.data.data);

          // Filter out duplicates before adding to tickets array
          const existingIds = new Set(context.state.tickets.map(t => t.id));
          const newTickets = first_response.data.data.filter(ticket => !existingIds.has(ticket.id));

          if (newTickets.length > 0) {
            context.state.tickets.push(...newTickets);
          }
        }
        context.state.tickets_count.out_of_hour = first_response.data.total || 0;
        context.state.tickets_out_of_hour = {
          data: first_response.data.data,
          pagination: first_response.data,
          current_page: first_response.data.current_page
        };
      })
    },
    async getTicketsCount(context, query_params = {}, force = false) {
      // Evita múltiplas chamadas simultâneas desnecessárias
      if (context.state.updating_counts && !force) {
        return;
      }

      try {
        context.state.updating_counts = true;
        const response = await api.get('/chat/tickets/count', { params: query_params });

        // Só atualiza se houve mudança real nos contadores
        const currentCounts = context.state.tickets_count;
        const newCounts = response.data;

        const hasChanged = Object.keys(newCounts).some(key =>
          currentCounts[key] !== newCounts[key]
        );

        if (hasChanged || force) {
          context.commit('SET_TICKETS_COUNT', newCounts);
        }
      } catch (error) {
        console.error('Erro ao buscar contadores de tickets:', error);
        if (error.response && error.response.status === 401) {
          await context.dispatch('logoutUser');
        }
        throw error;
      } finally {
        context.state.updating_counts = false;
      }
    },
    updateLocalTicketCounts(context, { oldStatus, newStatus }) {
      const statusMappings = {
        0: 'waiting',
        2: 'out_of_hour',
        3: 'in_operator',
        4: 'paused'
      };

      // Diminui contador do status antigo
      if (oldStatus !== undefined && statusMappings[oldStatus]) {
        const oldProperty = statusMappings[oldStatus];
        if (context.state.tickets_count[oldProperty] > 0) {
          context.state.tickets_count[oldProperty]--;
        }
      }

      // Aumenta contador do novo status
      if (newStatus !== undefined && statusMappings[newStatus]) {
        const newProperty = statusMappings[newStatus];
        context.state.tickets_count[newProperty]++;
      }
    },
    async getChatTickets(context, query_params) {
      context.state.getting_tickets = true;
      context.state.tickets = []; // Limpar tickets existentes

      const params = {
        ...query_params,
        page: 1 // Sempre começar com página 1
      };

      // Carregar apenas a primeira página de cada status
      await Promise.all([
        this.dispatch('getTicketsInOperator', params),
        this.dispatch('getTicketsWaiting', params),
        // this.dispatch('getTicketsPaused', params),
        // this.dispatch('getTicketsOutOfHour', params)
      ]);
      await this.dispatch('getTicketsCount', params);
      context.state.getting_tickets = false;
      context.state.first_load_completed = true;
      this.dispatch('stopLoading');
    },
    async loadTicketsByStatus(context, { status_key, query_params }) {
      const params = {
        ...query_params,
        page: 1
      };

      // Verificar qual propriedade do updated_after_filter usar
      const statusMappings = {
        2: 'out_of_hour',
        4: 'paused'
      };

      const statusProperty = statusMappings[status_key];

      if (statusProperty && !context.state.updated_after_filter[statusProperty]) {
        // Marcar como carregado ANTES de fazer a requisição para evitar chamadas duplicadas
        context.state.updated_after_filter[statusProperty] = true;
        try {
          switch (status_key) {
            case 2: // Out of Hour
              await this.dispatch('getTicketsOutOfHour', params);
              break;
            case 4: // Paused
              await this.dispatch('getTicketsPaused', params);
              break;
          }

          // Após carregar os dados do servidor, remover possíveis duplicatas
          context.dispatch('removeDuplicateTickets');
        } catch (error) {
          // Se der erro, reverter o flag para permitir nova tentativa
          context.state.updated_after_filter[statusProperty] = false;
          throw error;
        }
      }
    },

    // Nova action para remover duplicatas
    removeDuplicateTickets(context) {
      // Remover duplicatas da lista principal de tickets
      const uniqueTickets = [];
      const seenIds = new Set();

      for (const ticket of context.state.tickets) {
        if (!seenIds.has(ticket.id)) {
          seenIds.add(ticket.id);
          uniqueTickets.push(ticket);
        }
      }

      context.state.tickets = uniqueTickets;

      // Também limpar duplicatas das listas específicas de status
      const statusListMap = {
        2: 'tickets_out_of_hour',
        4: 'tickets_paused',
        0: 'tickets_waiting',
        3: 'tickets_in_operator'
      };

      Object.values(statusListMap).forEach(listKey => {
        if (context.state[listKey] && context.state[listKey].data) {
          const uniqueStatusTickets = [];
          const seenStatusIds = new Set();

          for (const ticket of context.state[listKey].data) {
            if (!seenStatusIds.has(ticket.id)) {
              seenStatusIds.add(ticket.id);
              uniqueStatusTickets.push(ticket);
            }
          }

          context.state[listKey].data = uniqueStatusTickets;
        }
      });
    },
    getChatsData(context, payload) {
      let ids = [];
      payload.forEach(p => {
        const item = context.state.data.find(i => {
          return p === i.ticket_id
        });
        if (item === undefined) {
          ids.push(p);
        }
      });
      if (ids.length > 0) {
        api.post(`/chat`, { ids }).then(response => {
          context.commit("SET_CHAT_TICKETS", response.data);
        }).catch(error => {
          if (error.response.status === 401) {
            this.dispatch('logoutUser');
          }
        });
      }
    },
    getChatsAll(context) {
      api.get(`/chat/all`).then(response => {
        context.commit("SET_CHAT_TICKETS", response.data);
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },
    async verifyContactHasWhatsapp(context, payload) {
      let result_verification;
      if (payload.lead.status_key == 0) {
        // CONTATO NÃO VERIFICADO
        await api.post('https://whatsapp.beelabs.com.br/chat/whatsappNumbers/instance-verify',
          { numbers: [payload.lead.phone] },
          { headers: { 'apikey': 'instance-verify' } }
        ).then((response) => {

          if (response.data[0].exists == false) {
            // WHATSAPP NÃO EXISTE, SALVA O CONTATO COMO INVÁLIDO
            Swal.fire({
              title: `${context.rootGetters.getTranslations('expression_760')}`,
              html: `${context.rootGetters.getTranslations('expression_217')}`,
              icon: 'error',
              showCancelButton: false,
              confirmButtonColor: 'btn-primary',
              confirmButtonText: `Ok`
              // confirmButtonText: `${context.rootGetters.getTranslations('expression_1289')}`
              // cancelButtonText: context.rootGetters.getTranslations('expression_355')
            })
            const update_lead = {
              id: payload.lead.id,
              status_key: 2
            }
            this.dispatch('updateLead', update_lead)

            result_verification = false;

          } else {
            // WHATSAPP EXISTE, PODE ENVIAR MENSAGEM
            result_verification = true;
          };
        }).catch(error => {
          result_verification = true;
          // ERRO AO VERIFICAR EXISTÊNCIA DE CONTA NO WHATSAPP
          // DAR A POSSIBILIDADE DE ENVIAR A MENSAGEM MESMO ASSIM
          // Swal.fire({
          //   title: `${context.rootGetters.getTranslations('expression_213')}`,
          //   html: `${context.rootGetters.getTranslations('expression_407')}`,
          //   icon: 'warning',
          //   // showCancelButton: false,
          //   confirmButtonColor: 'btn-primary',
          //   confirmButtonText: `${context.rootGetters.getTranslations('expression_978')}`,
          //   cancelButtonText: context.rootGetters.getTranslations('expression_499')
          // }).then((result) => {
          //   if(result.isConfirmed) {
          //     result_verification = true;
          //   }
          // })
        })
      } else if (payload.lead.status_key == 2) {
        // CONTATO INVÁLIDO, SEQUER VAI EXISTIR VERIFICAÇÃO
        Swal.fire({
          title: `${context.rootGetters.getTranslations('expression_760')}`,
          html: `${context.rootGetters.getTranslations('expression_140')}`,
          icon: 'error',
          showCancelButton: false,
          confirmButtonColor: 'btn-primary',
          confirmButtonText: `Ok`
        })

        result_verification = false;
      } else {
        result_verification = true;
      }
      return result_verification;
    },
    async sendMessage(context, payload) {
      const channel = context.rootGetters.getChannelObject('id', payload.channel_id)
      const lead = context.rootGetters.getLeadObject('id', context.state.ticket.lead_id)
      let allowed_to_send_message = false

      if (lead.phone.length > 8 && channel.type_key == 0) {
        allowed_to_send_message = await this.dispatch('verifyContactHasWhatsapp', { channel: channel, lead: lead })
      } else {
        allowed_to_send_message = true;
      }

      if (allowed_to_send_message) {
        api.post(`/chat/history`, payload).then(response => {
          window.document.getElementById('chatTextArea').focus();
          context.state.button_disabled = false;
          if (['error_operator_id', 'error_department_id', 'error_status_key'].includes(response.data.message)) {
            const chatTicketKey = context.state.tickets.findIndex(chat => {
              return chat.id === payload.ticket_id
            })
            if (chatTicketKey > -1) {
              context.state.tickets.splice(chatTicketKey, 1);
            }
            if (context.state.ticket.id === payload.ticket_id) {
              context.state.ticket = {}
            }
            window.document.getElementById('chatTextArea').focus();
            Swal.fire({
              position: 'center',
              icon: 'warning',
              title: `${context.rootGetters.getTranslations('expression_1114')}`,
              showConfirmButton: true,
              // timer: 1000
            })
          }
        }).catch(error => {
          window.document.getElementById('chatTextArea').focus();
          context.state.button_disabled = false;
          if (error.response.status === 401) {
            this.dispatch('logoutUser');
          }
        });
      }
    },
    resendMessage(context, payload) {
      api.post(`chat/resend-message/${payload}`).then((response) => {
        setTimeout(() => {
          context.commit("SET_LOAD_RESEND_MESSAGE", false);
          // context.commit("SET_BTN_RESEND_MESSAGE", false);

          // Swal.fire({
          //   position: 'center',
          //   icon: 'success',
          //   title: 'Sucesso',
          //   text: 'Mensagem reenviada com sucesso!',
          //   showConfirmButton: true
          // })
        }, 4000)
      }).catch((error) => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      })
    },
    sendHsm(context, payload) {
      const channel = context.rootGetters.getChannelObject('id', payload.channel_id)
      const lead = context.rootGetters.getLeadObject('id', context.state.ticket.lead_id)
      let allowed_to_send_message = false;

      if (lead.phone.length > 8 && channel.type_key == 0) {
        allowed_to_send_message = this.dispatch('verifyContactHasWhatsapp', { channel: channel, lead: lead })
      } else {
        allowed_to_send_message = true
      }

      if (allowed_to_send_message) {
        api.post(`/chat/hsm`, payload).then(() => {
        }).catch(error => {
          if (error.response.status === 401) {
            this.dispatch('logoutUser');
          }
        });
      }
    },
    async ticketTransfer(context, payload) {
      try {
        const response = await api.post(`/chat/ticket/transfer`, payload);

        if (['error_operator_id', 'error_department_id', 'error_status_key'].includes(response.data.message)) {
          const chatTicketKey = context.state.tickets.findIndex(chat => {
            return chat.id === payload.ticket_id
          });

          if (chatTicketKey > -1) {
            context.state.tickets.splice(chatTicketKey, 1);
          }

          if (context.state.ticket.id === payload.ticket_id) {
            context.state.ticket = {}
          }

          Swal.fire({
            position: 'center',
            icon: 'warning',
            title: `${context.rootGetters.getTranslations('expression_1114')}`,
            showConfirmButton: true,
          });
        } else {
          // Transferência bem-sucedida - atualizar estado local
          const transferredTicketId = payload.ticket_id;

          // Remover da lista principal
          context.state.tickets = context.state.tickets.filter(ticket => ticket.id !== transferredTicketId);

          // Remover das listas específicas de status
          const statusListMap = {
            2: 'tickets_out_of_hour',
            4: 'tickets_paused',
            0: 'tickets_waiting',
            3: 'tickets_in_operator'
          };

          Object.values(statusListMap).forEach(listKey => {
            if (context.state[listKey] && context.state[listKey].data) {
              context.state[listKey].data = context.state[listKey].data.filter(ticket => ticket.id !== transferredTicketId);
            }
          });

          // Se era o ticket ativo, limpar
          if (context.state.ticket.id === transferredTicketId) {
            context.state.ticket = {};
            context.state.histories_current_ticket = [];
          }

          // Atualizar contadores
          await context.dispatch('getTicketsCount', context.state.filter_search);

          Swal.fire({
            position: 'center',
            icon: 'success',
            title: `${context.rootGetters.getTranslations('expression_913')}`,
            showConfirmButton: false,
            timer: 1000
          });
        }
      } catch (error) {
        if (error.response?.status === 401) {
          await context.dispatch('logoutUser');
        }
        throw error;
      }
    },
    async closeTicket(context, payload) {
      try {
        await api.post(`/chat/ticket/close`, payload);

        // Remover o ticket da lista principal
        context.state.tickets = context.state.tickets.filter(ticket => ticket.id !== payload.id);

        // Remover das listas específicas de status
        const statusListMap = {
          2: 'tickets_out_of_hour',
          4: 'tickets_paused',
          0: 'tickets_waiting',
          3: 'tickets_in_operator'
        };

        Object.values(statusListMap).forEach(listKey => {
          if (context.state[listKey] && context.state[listKey].data) {
            context.state[listKey].data = context.state[listKey].data.filter(ticket => ticket.id !== payload.id);
          }
        });

        // Atualizar contadores
        await context.dispatch('getTicketsCount', context.state.filter_search);

        // Se era o ticket ativo, limpar
        if (context.state.ticket.id === payload.id) {
          context.state.ticket = {};
          context.state.histories_current_ticket = [];
        }

        Swal.fire({
          position: 'center',
          icon: 'success',
          title: `${context.rootGetters.getTranslations('expression_914')}`,
          showConfirmButton: false,
          timer: 1000
        });
      } catch (error) {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
        throw error;
      }
    },
    removeTicketFromList(context, ticketId) {
      // Remover da lista principal
      context.state.tickets = context.state.tickets.filter(ticket => ticket.id !== ticketId);

      // Remover das listas específicas de status
      const statusListMap = {
        2: 'tickets_out_of_hour',
        4: 'tickets_paused',
        0: 'tickets_waiting',
        3: 'tickets_in_operator'
      };

      Object.values(statusListMap).forEach(listKey => {
        if (context.state[listKey] && context.state[listKey].data) {
          context.state[listKey].data = context.state[listKey].data.filter(ticket => ticket.id !== ticketId);
        }
      });

      // Atualizar contadores
      Object.keys(context.state.tickets_count).forEach(status => {
        const count = context.state.tickets_count[status];
        if (count > 0) {
          context.state.tickets_count[status] = Math.max(0, count - 1);
        }
      });
    },
    getOldHistories(context, payload) {
      api.get('/histories', {
        params: payload
      }).then(response => {
        context.commit("SET_OLD_HISTORIES", response.data);
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },
    getOldTickets(context, payload) {
      api.get('/tickets', {
        params: payload
      }).then(response => {
        context.commit("SET_OLD_TICKETS", response.data);
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },
    getLeadsBook(context, payload) {
      api.get('/leads', { params: payload }).then(response => {
        context.commit("SET_LEADS_BOOK_PAGINATION", response.data);
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },
    getLeadCheck(context, payload) {
      //if(payload.phone_ddi !== ""){
      //  payload.phone = payload.phone_ddi + payload.phone;
      //}
      api.post('/chat/lead/check', payload).then(response => {
        context.commit("SET_LEAD_CHECK", response.data);
        if (response.data.ticket && response.data.ticket.id) {
          context.commit("SET_TICKET_STEP", 1);
        } else {
          context.commit("SET_TICKET_STEP", 2);
        }
        window.VueComponent.$root.$emit('setLoadingVerifyLeadFalse');
      }).catch(error => {
        if (error.response && error.response.status === 401) {
          this.dispatch('logoutUser');
        } else {
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: context.rootGetters.getTranslations('expression_1219'),
            showConfirmButton: false,
            timer: 3000
          })
        }
        window.VueComponent.$root.$emit('setLoadingVerifyLeadFalse');
        window.VueComponent.$root.$emit('resetChannelIdOnCreateLead');
      });
    },
    async newTicket(context, payload) {
      context.state.histories_current_ticket = [];

      try {
        const response = await api.post('/chat/ticket/new', payload);

        // Atualizar contadores E recarregar tickets em paralelo
        await Promise.all([
          context.dispatch('getTicketsCount', context.state.filter_search),
          context.dispatch('getTicketsWaiting', context.state.filter_search)
        ]);

        // depois de carregar o waiting, escolhe o novo ticket como ativo
        setTimeout(() => {
          const idx = context.state.tickets.findIndex(t => t.id === response.data.id);
          if (idx !== -1) {
            context.state.filter_search.status_key = context.state.tickets[idx].status_key;
            context.state.ticket = context.state.tickets[idx];
          }
        }, 300); // Reduzido de 800ms para 300ms

      } catch (err) {
        if (err.response?.status === 401) {
          await context.dispatch('logoutUser');
        } else {
          console.error(err);
        }
      }
    },
    newLead(context, payload) {
      api.post('/leads', payload).then(response => {
        if (payload.route_name) {
          Swal.fire({
            position: 'center',
            icon: 'success',
            title: context.rootGetters.getTranslations('expression_915'),
            showConfirmButton: false,
            timer: 1000
          })

          this.dispatch("getLeads", context.rootState.leads.search_lead);
          this.dispatch("getLeadsInfo", context.rootState.leads.search_lead);
          context.rootState.leads.filter_leads_active = true;
        } else {
          context.commit("SET_LEAD_CHECK", response.data);
        }
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },
    getWalletCheck(context, payload) {
      api.post('/chat/wallet/check', payload).then(response => {
        context.commit("SET_WALLET_CHECK", response.data);
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },


    async updateTicketChat(context, payload) {
      try {
        const oldTicket = context.state.tickets.find(t => t.id === payload.id);
        const oldStatus = oldTicket?.status_key;

        await api.put(`/tickets/${payload.id}`, payload);

        // Atualiza contadores localmente primeiro (resposta mais rápida)
        if (payload.status_key !== undefined && payload.status_key !== oldStatus) {
          context.dispatch('updateLocalTicketCounts', {
            oldStatus: oldStatus,
            newStatus: payload.status_key
          });

          context.commit('SYNC_TICKET_STATUS', {
            ticketId: payload.id,
            newStatus: payload.status_key
          });
        }

        // Atualiza contadores no servidor em background
        setTimeout(() => {
          context.dispatch('getTicketsCount', context.state.filter_search, true);
        }, 1000);

      } catch (error) {
        console.error('Erro ao atualizar ticket:', error);
        // Em caso de erro, força atualização dos contadores do servidor
        context.dispatch('getTicketsCount', context.state.filter_search, true);
        throw error;
      }
    },

    lastHistoryLeadChat(context, payload) {
      api.post(`/chat/history/lead/last`, {
        lead_id: payload.id
      }).then(response => {
        this.dispatch('setHistoryLead', response.data);
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },
    hookActive(context, payload) {
      this.dispatch('setHistoryLead', {});
      const histories = context.getters.getHistoriesArray('ticket_id', context.state.ticket.id)
      if (histories.length > 0) {
        const histories_lead = histories.filter(item => {
          return item.origin_key === 0;
        });
        if (histories_lead.length > 0) {
          const max = histories_lead.reduce((prev, current) => (prev.id > current.id) ? prev : current)
          this.dispatch('setHistoryLead', max);
        } else {
          this.dispatch('lastHistoryLeadChat', { id: context.state.ticket.lead_id });
        }
      }
      return histories
    },
    chatLeadRemaining(context, payload) {
      if (window.route.name === 'Chat') {
        context.state.loading_chat = true;
      }
      api.post(`/chat/lead/remaining/${payload.id}`).then(response => {
        const leadKey = context.rootState.leads.data.findIndex(leadData => {
          return leadData.id === payload.id
        })
        if (leadKey > -1) {
          context.rootState.leads.data[leadKey].remaining = response.data.remaining;
          context.rootState.leads.data[leadKey].send_history = response.data.send_history;
        }

        if (window.route.name === 'Chat') {
          context.state.loading_chat = false;
        }
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },
  },
}
export default chat;
